export const FEATURE_DOCUSIGN = 'DOCUSIGN';
